export default __webpack_public_path__ + "static/media/pokemon-logo.25821459.png";